
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/snackbar/snackbar-message.component.js'
      import type { DdsCloseEvent } from '../../events/events'
      export type { DdsCloseEvent } from '../../events/events'

      const tagName = 'dap-ds-snackbar-message'

      /**
 * `dap-ds-snackbar-message`
 * @summary The Snackbar component shows a sliding message to the user.
 * @element dap-ds-snackbar-message
 * @title - Snackbar message
 * @group snackbar
 *
 * @event {{ id: string }} dds-close - Fires when the snackbar closes.
 *
 * @slot default - The content of the snackbar.
 *
 * @csspart base - Main snackbar container.
 * @csspart text - The text part of the snackbar.
 * @csspart closebutton - The close button part of the component.
 * @csspart icon - The icon part of the close button.
 *
 * @cssproperty --dds-snackbar-width - Width of the snackbar.
 * @cssproperty --dds-snackbar-gap - Gap between snackbar elements.
 * @cssproperty --dds-snackbar-padding - Padding inside the snackbar.
 * @cssproperty --dds-snackbar-margin-bottom - Bottom margin of the snackbar.
 * @cssproperty --dds-snackbar-transition - Transition property for the snackbar.
 * @cssproperty --dds-snackbar-border-width - Border width of the snackbar.
 * @cssproperty --dds-snackbar-border-radius - Border radius of the snackbar.
 * @cssproperty --dds-snackbar-font-size - Font size used in the snackbar.
 * @cssproperty --dds-snackbar-background - Background color of the snackbar.
 * @cssproperty --dds-snackbar-border - Border color of the snackbar.
 * @cssproperty --dds-snackbar-text - Text color of the snackbar.
 * @cssproperty --dds-snackbar-icon - Icon color of the snackbar.
 * @cssproperty --dds-snackbar-link - Link color of the snackbar.
 * @cssproperty --dds-snackbar-information-background - Background color for information variant.
 * @cssproperty --dds-snackbar-information-border - Border color for information variant.
 * @cssproperty --dds-snackbar-information-icon - Icon color for information variant.
 * @cssproperty --dds-snackbar-success-background - Background color for success variant.
 * @cssproperty --dds-snackbar-success-border - Border color for success variant.
 * @cssproperty --dds-snackbar-success-icon - Icon color for success variant.
 * @cssproperty --dds-snackbar-error-background - Background color for error variant.
 * @cssproperty --dds-snackbar-error-border - Border color for error variant.
 * @cssproperty --dds-snackbar-error-icon - Icon color for error variant.
 * @cssproperty --dds-snackbar-variant-text - Text color for information, success, and error variants.
 * @cssproperty --dds-snackbar-variant-icon - Icon color for information, success, and error variants.
 * @cssproperty --dds-snackbar-variant-link - Link color for information, success, and error variants.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsClose: 'dds-close' as EventName<DdsCloseEvent>
        },
        displayName: "DapDSSnackbarMessage"
      })

      export default reactWrapper
    